<template>
  <div id="fourPage">
    <!-- 当前成交查询 -->
    <div class="transcc_new_NewFooter_tabs_mid">
      <div class="transcc_search">
        <!-- <div class="itemSearch">
          <span class="title">商品代码</span>
          <el-select
            v-model="search.commodityCode"
            class="searchSelect"
            size="small"
            filterable
            placeholder="显示全部"
            @change="changeCode"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.commodityCode"
              :value="item.commodityCode"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch">
          <span class="title">商品名称</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.symbol"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
            @change="changeSymbol"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbol"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">买 | 卖</span>
          <el-select
          :popper-append-to-body="true"
            v-model="search.bsFlag"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title zrTitle">订立 | 转让</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.selectWay"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in wayOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch actionSearch">
          <el-button
            plain
            class="errorBtn"
            size="small"
            style="width: 74px;height: 24px;color:#0486fe;background: #D94066;font-size:14px;"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="greenBtn"
            size="small"
            style="width: 74px;height: 24px;color:#fff;background: #41B37D;font-size:14px;"
            @click="restData"
          >重置</el-button>
        </div>
        <!-- <div class="itemSearch">
          <span class="title miTitle">只显示止盈止损单</span>
          <el-switch
            v-model="value"
            class="searchSelect"
            active-color="#13ce66"
            inactive-color="#D9D9D9"
          >
          </el-switch>
        </div> -->
      </div>
    </div>
    <div class="transcc_new_NewFooter_tabs_tabBox">
      <!-- <div class="transcc_new_NewFooter_tabs_tabBox_head"> -->
      <el-table
        class="table_style"
        ref="table"
        :data="tableData"
        height="256"
        row-class-name="row"
        style="width: 100%;"
        :cell-class-name="directionClass"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <el-table-column
          prop="tradeId"
          label="成交单号"
          align="center"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="orderId"
          label="委托单号"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="成交时间"
          min-width="130"
          align="center"
        >

        </el-table-column>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
          width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买 | 卖"
          sortable="custom"
          min-width="80"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="tradeType"
          label="订立 | 转让"
          min-width="105"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.tradeType | tradeTypeFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradePrice"
          label="订立价格"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ Number(scope.row.tradePrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="成交数量"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="totalAmount"
          label="成交金额"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="cjjg"
          label="转让价格"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.ocFlag=='转让' ? scope.row.singlePrice : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="closePl"
          label="转让盈亏"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span> {{ util.floatAdd(scope.row.closePl, scope.row.holdClosePl) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="stampFee"
          label="印花税"
          width="80"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.stampFee }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="fee"
          label="交易手续费"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.fee }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="成交类型"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> 正常交易</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24">
          <el-pagination
            class="pagination_style"
            popper-class="dark_popStyle"
            :current-page="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      checked: false,
      tableData: [
      //   {
      //   bsFlag: 'S',
      //   closePl: 0,
      //   commodityCode: 'YH2210',
      //   commodityId: 243,
      //   commodityName: '红皮洋葱2210',
      //   createTime: 1639492292000,
      //   fee: 12.01,
      //   firmId: 5852,
      //   holdDetailId: 692573,
      //   margin: 800.6,
      //   minPriceChange: 1,
      //   ocFlag: 'O',
      //   orderId: 931868,
      //   priceScale: 0,
      //   quantity: 1,
      //   tradePrice: 4003,
      //   stampFee: 0,
      //   stampFeeRate: 0,
      //   tqTip: 0,
      //   tradeDay: 20211214,
      //   tradeId: 1273609,
      //   tradeType: 1,
      //   updateTime: 1639492292000
      // }
      ],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 6,
        currentPage: 1
      },
      search: {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        status: null,
        floatPl: null,
        startTime: null,
        endTime: null,
        time: null,
        selectWay: 0,
        commodityId: null
      },
      bsFlagOptions: [{
        value: null,
        label: '全部'
      },
      {
        value: 'B',
        label: '买入'
      }, {
        value: 'S',
        label: '卖出'
      }],
      wayOptions: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '订立'
        },
        {
          value: 2,
          label: '转让'
        },
        {
          value: 4,
          label: '代为转让'
        }
        // {
        //   value: 15,
        //   label: '到期转让'
        // }
      ],
      TradeListSum: {
        'quantity': 0,
        'totalAmount': '',
        'closePl': 0,
        'holdClosePl': 0,
        'fee': 0
      },
      isNetWrong: false
    }
  },
  updated() {
      this.$nextTick(() => {
          this.$refs.table.doLayout()
      })
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'h_tradeTime']),
    commodityOptions() {
        const commodityList = structuredClone(this.$store.state.hqData.marketDetails)
      commodityList.unshift({commodityId: null,symbol: '全部'})
      return commodityList
    }
  },
  watch: {
    h_tradeTime() {
      this.showData()
    }
  },
  mounted() {
    this.showData()
  },
  methods: {
    restData() {
      this.search = {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        status: null,
        floatPl: null,
        startTime: null,
        endTime: null,
        time: null,
        selectWay: 0,
        commodityId: null
      }
      this.pageData.currentPage = 1
      this.showData()
    },
    searchData() {
      this.pageData.currentPage = 1
      // protocol.queryUserClinchesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      // protocol.queryUserClinchesNew.data.commodityId = this.search.commodityId
      // protocol.queryUserClinchesNew.data.orderStatus = this.search.status != null ? [this.search.status] : null
      this.showData()
    },
    changeCode(code) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.search.commodityCode = element.commodityCode
          this.search.symbol = element.symbol
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    changeSymbol(symbol) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if(element.symbol == '全部'){
           this.search.commodityId = null
           this.search.symbol = element.symbol
           this.search.commodityCode = null
           return
        }else if (element.symbol === symbol) {
          this.search.symbol = element.symbol
          this.search.commodityCode = element.commodityCode
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      protocol.queryUserClinchesNew.data.page = this.pageData.currentPage - 1
      protocol.queryUserClinchesNew.data.size = '' + this.pageData.pageSize
      // protocol.queryUserClinchesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserClinchesNew.data.commodityId = this.search.commodityId
      protocol.queryUserClinchesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserClinchesNew.data.commodityId = this.search.commodityId
      protocol.queryUserClinchesNew.data.orderStatus = this.search.status != null ? [this.search.status] : null
      protocol.queryUserClinchesNew.data.tradeType = this.search.selectWay == 0 ? [1, 2, 4, 8, 15] : [this.search.selectWay]
      // protocol.queryUserClinchesNew.data.sort = [{
      //   direction: 'DESC',
      //   property: 'createTime'
      // }]
      http.gPost(protocol.queryUserClinchesNew).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            this.TradeListSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
              'quantity': 0,
              'totalAmount': '',
              'closePl': 0,
              'holdClosePl': 0,
              'fee': 0
            }
          }
        }
      }).catch((e) => {
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return 'white-row'
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.textColor = ''
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.closePl))
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserClinchesNew.data.sort = [{
          'direction': 'ASC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserClinchesNew.data.sort = [{
          'direction': 'DESC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else {
        protocol.queryUserClinchesNew.data.sort = [{
          property: 'tradeId',
          direction: 'DESC'
        }]
      }
      protocol.queryUserClinchesNew.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        http.gPost(protocol.queryUserClinchesNew).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.TradeListSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
                'quantity': 0,
                'totalAmount': '',
                'closePl': 0,
                'holdClosePl': 0,
                'fee': 0
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinchesNew.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = Number(that.TradeListSum.totalAmount).toFixed(2)
          return
        }
        if (index === 10) { // 利润
          sums[index] = this.util.floatAdd(that.TradeListSum.closePl, that.TradeListSum.holdClosePl.toFixed(2))
          return
        }
        if (index === 11) { // 手续费
          sums[index] = Number(that.TradeListSum.fee).toFixed(2)
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      if (row.columnIndex == 4) {
        return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
      }
      if (row.columnIndex == 5) {
        return this.setStrClass(row.row.ocFlag, '转让', 'dropColor', 'increaseColor')
      }
    }
  }

}
</script>
<style lang="scss" scoped>
/deep/ .dropColor > *{
  color: #41B37D !important;
}
/deep/ .el-table__footer-wrapper .el-table__footer{
    height: 36px !important;
}
/deep/ .el-table__row{
  height: 32px;
}
/deep/ .el-table td div{
  text-align: center;
  color: #dfdfdf;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
</style>
<style lang="scss" scoped>
//el-selecl Style
::v-deep .el-input--small .el-input__icon{
  line-height: 26px;
}
.el-select-dropdown__item.selected{
  color: #989898
}
</style>
<style lang="scss" scoped>
/deep/ .el-table table tr{
   background-color: #161719;
}
// #threePage{
//  width:calc(100% - 181px);
// }
.transcc_search{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3px 0;
  .itemSearch{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    .title{
      width:60px;
      font-size:14px;
      // margin:0 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
    }
    .zrTitle{
      width:73px;
    }
    .searchSelect{
      width:158px!important;
      height: 26px;
    }
    .decTitle{
      width: 44px;
    }
    .miTitle{
      width:120px;
    }
  }
  /deep/ .el-input.is-focus .el-input__inner{
        border-color: #fff !important;
  }
  /deep/  .el-input__inner{
        height: 26px !important;
        background-color: transparent;
        border-color: rgba($color: #fff, $alpha: 0.3);
        color: #979797;
      }
   /deep/.el-button{
     border:none;
     border-radius: 15px;
    padding: 5px 15px !important;
   }
  /deep/.el-button span {
    color: #fff;
  }
  .actionSearch{
    margin-left:10px;
  }

}
/deep/.el-range-editor .el-range-input{
  background-color:transparent;
}
/deep/.el-date-editor .el-range-separator{
  color: rgba(255, 255, 255, 0.4);
}
// .transcc_new_NewFooter_tabs_mid{
//   min-width:1200px;
// }
 .transcc_query_search {
        margin-top: 16px;
        .el-button{
          width:52px;
          height: 32px;
          background-color:transparent;
          border: 1px solid #363F66;
        }
      }
      .transcc_new_NewFooter_tabs_tabBox {
        width: 100%;
        min-width: 1200px;
        .row{
          background-color: #010101 !important;
        }
        .transcc_new_NewFooter_tabs_tabBox_head {
          width: 100%;
          display: flex;
          // justify-content: space-around;
          align-items: center;
          height: 60px;
          .tab_head_item {
            width: 130px;
            margin-left: 10px;
            display: flex;
            align-items: center;
            height: 14px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.6);
            line-height: 14px;
          }
        }
        .borderline {
          width: 100%;
          height: 1px;
          background: linear-gradient(
            45deg,
            rgba(94, 101, 146, 0.4) 0%,
            #464c74 53%,
            rgba(48, 53, 89, 0.4) 100%
          );
        }
      }
</style>
<style lang="scss">
#transcc_new_NewFooter #fourPage .el-table__footer-wrapper td:nth-child(n + 6) .cell {
  color: #fff;
}

</style>
